import type React from 'react';
import SettingStyles from '../SettingStyle.module.scss';
import { AccountSettingForm } from '~/components/specifics/vendors/settings/accounts/AccountSettingForm';
import { AccountSettingPassword } from '~/components/specifics/vendors/settings/accounts/AccountSettingPassword';

export const AccountSetting: React.FC = () => (
  <>
    <h3 className={SettingStyles.SettingTitle}>アカウント詳細</h3>
    <AccountSettingForm />
    <AccountSettingPassword />
  </>
);
